<div
	class="drop-zone"
	[class.drag-over]="isDragOver"
	[class.compact]="size === 'compact'"
	[class.uploading]="state === 'uploading'"
	[class.complete]="state === 'complete'"
	[style.background]="backgroundColor"
	(dragover)="onDragOver($event)"
	(dragleave)="onDragLeave($event)"
	(drop)="onDrop($event)"
>
	<!-- Idle state: normal dropzone -->
	@if (state === 'idle') {
		<div class="drop-zone-content">
			<div class="drop-zone-icon">
				<img [src]="imageSrc" [alt]="imageAlt" class="drop-image" />
			</div>

			<p class="drop-zone-text" [innerHTML]="title"></p>

			<p class="drop-zone-subtext">
				@if (subtitle.includes(selectText)) {
					{{ subtitle.split(selectText)[0] }}
					<span class="link" (click)="triggerFileInput(fileInput)">{{ selectText }}</span>
					{{ subtitle.split(selectText)[1] || '' }}
				} @else {
					{{ subtitle }}
				}
			</p>

			<div class="upload-button-container">
				<app-button
					[label]="buttonLabel"
					variant="primary"
					size="large"
					(onClick)="triggerFileInput(fileInput)"
				></app-button>
			</div>
		</div>
	}

	<!-- Uploading state: upload progress -->
	@if (state === 'uploading') {
		<div class="upload-progress-content">
			<div class="progress-percentage">{{ progress | number : '1.0-0' }}%</div>

			<div class="progress-bar-wrapper">
				<div class="progress-bar" [style.width.%]="progress"></div>
			</div>

			<p class="progress-text">{{ uploadingText }}</p>
			<p class="progress-subtext">{{ filesCountText }}</p>
		</div>
	}

	<!-- Complete state: upload finished -->
	@if (state === 'complete') {
		<div class="upload-complete-content">
			<div class="progress-percentage">100%</div>

			<div class="progress-bar-wrapper">
				<div class="progress-bar complete" [style.width.%]="100"></div>
			</div>

			<p class="progress-text">{{ completeText }}</p>

			@if (hasErrors) {
				<p class="error-warning">
					<lucide-icon name="AlertCircle" [size]="16"></lucide-icon>
					{{ errorMessage }}
				</p>
			} @else {
				<p class="progress-subtext">{{ filesCountText }}</p>
			}

			<div class="complete-actions">
				<app-button
					[label]="viewFilesLabel"
					variant="primary"
					size="medium"
					(onClick)="onViewFiles()"
				></app-button>

				@if (hasErrors) {
					<app-button
						[label]="viewErrorsLabel"
						variant="secondary"
						size="medium"
						(onClick)="onViewErrors()"
					></app-button>
				}
			</div>
		</div>
	}

	<!-- Hidden File Input -->
	<input
		#fileInput
		type="file"
		[multiple]="multiple"
		[accept]="accept"
		(change)="onFileSelect($event)"
		style="display: none"
	/>
</div>
